/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Button } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import React, { useContext } from 'react';
import { ApiContext } from '../../../../context/ApiContext';
import descriptors from '../../../../locales/en-US/descriptors';
import { IAny } from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import { UpdatedTemplateDownloadList } from '../../../shared/Utils/Constants';
import UpdatedUploadTab from '../UploadTab/UpdatedUploadTab';
import './UpdatedChooseDataTypeThemes.scss';

function UpdatedChooseDataTypeTab(props: {
  selectedDataType: string;
  onSelectDataType: Function;
  setUploadDisabled?: IAny;
  dataError?: IAny;
  setUploadDisableonFileError: Function;
}) {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const {
    selectedDataType,
    onSelectDataType,
    dataError,
    setUploadDisableonFileError
  } = props;
  const apiContext = useContext(ApiContext);
  const { onNewTemplateDownloadClick } = apiContext;
  const selectedTemplateObject = UpdatedTemplateDownloadList.find(
    (x) => x.type === selectedDataType
  );
  return (
    <div className="updated-meter-data-upload">
      <div className="updated-meter-data-choose-type-tab">
        <div className="instructions-part">
          <div className="instruction-header">
            <span>{t(d.INSTRUCTIONSFORFILLINGTHETEMPLATE)}</span>
          </div>
          <div className="instructions-list">
            <li>
              <span>{t(d.INSTRUCTIONTEMPLATEONE)}</span>
              <span>
                <br />
              </span>
              <Button
                type="link"
                className="download-csv-template-text"
                onClick={() => {
                  if (onNewTemplateDownloadClick)
                    // Download blank template
                    onNewTemplateDownloadClick(
                      selectedDataType,
                      selectedTemplateObject?.templateFiles
                        .PointHistoryReferenceSchema.downloadFile || '',
                      selectedTemplateObject?.templateFiles
                        .PointHistoryReferenceSchema.uploadType || ''
                    );
                }}
              >
                {t(d.METERUPLOADDOWNLOADCSV)}
              </Button>
            </li>
            <li>{t(d.INSTRUCTIONTEMPLATEONEPOINTFIVE)}</li>
            <li>{t(d.INSTRUCTIONTEMPLATETWO)}</li>
            <li>{t(d.INSTRUCTIONTEMPLATEFIVE)}</li>
            <li>{t(d.INSTRUCTIONTEMPLATETHREE)}</li>
            <li>
              <Button
                type="link"
                className="download-csv-template-text"
                onClick={() => {
                  if (onNewTemplateDownloadClick)
                    // Download filled template
                    onNewTemplateDownloadClick(
                      selectedDataType,
                      selectedTemplateObject?.templateFiles
                        .PointHistoryReferenceSchemaFilled.downloadFile || '',
                      selectedTemplateObject?.templateFiles
                        .PointHistoryReferenceSchemaFilled.uploadType || ''
                    );
                }}
              >
                {t(d.INSTRUCTIONTEMPLATEFOUR)}
              </Button>
            </li>
          </div>
        </div>
        <div className="meter-data-upload">
          <UpdatedUploadTab
            selectedDataType={selectedDataType}
            setUploadDisabled={props.setUploadDisabled}
            setUploadDisableonFileError={setUploadDisableonFileError}
            dataError={dataError}
          />
        </div>
      </div>
    </div>
  );
}

export default UpdatedChooseDataTypeTab;
